<template>
    <div class="utility-callout-wrapper w-largeDesktop ml-auto mr-auto flex items-center px-spc15 mb-spc16">
        <div class="callout-item w-2/6 pr-5 xl:text-left md:text-center">
            <h1 class="callout-title flex items-end text-size28 font-semibold text-white h-12 xl:justify-start md:justify-center">
                AWD
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc5 text-white lg:block md:hidden">
                Dual Motor All-Wheel Drive instantly controls traction and torque, in all weather conditions
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc5 text-white md:block lg:hidden">
                Standard <br>All-Wheel Drive
            </p>
        </div>
        <div class="callout-item w-2/6 px-5 xl:text-left md:text-center">
            <div class="callout-title flex items-center text-size28 font-semibold text-white h-12">
                <div class="speedmeter bg-center items-end bg-no-repeat inline-block relative h-h27 w-w44 mr-spc17 overflow-hidden"></div>
                <h1 class="flex relative xl:justify-start md:justify-center">
                                <span class="meter meterNum1">
                                    <span class="meterNum text-size28 leading-9">
                                        0 <br>
                                        1 <br>
                                        2 <br>
                                        3 <br>
                                        4 <br>
                                        5 <br>
                                        6 <br>
                                        7 <br>
                                        8 <br>
                                        9
                                    </span>
                                </span> .
                    <span class="meter meterNum2">
                                    <span class="meterNum text-size28 leading-9">
                                        0 <br>
                                        1 <br>
                                        2 <br>
                                        3 <br>
                                        4 <br>
                                        5 <br>
                                        6 <br>
                                        7 <br>
                                        8 <br>
                                        9
                                    </span>
                                </span>
                    <span class="s text-size28 font-medium">s</span>
                </h1>
            </div>
            <p class="callout-desc text-xs font-medium leading-spc5 text-white lg:block md:hidden">
                The quickest SUV on earth—from zero to 60 mph in as little as 2.6 seconds
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc5 text-white md:block lg:hidden">
                0-60 mph in <br>2.6 secs
            </p>
        </div>
        <div class="callout-item w-2/6 pl-5 xl:text-left md:text-center">
            <h1 class="callout-title flex items-center text-14 text-white h-12 xl:justify-start md:justify-center md:h-10">
                <span class="stars">★★★★★</span>
            </h1>
            <p class="callout-desc text-xs font-medium leading-spc5 text-white lg:block md:hidden">
                The highest safety ratings ever, with the lowest probability of occupant injury
            </p>
            <p class="callout-desc rp text-xs font-medium leading-spc5 text-white lg:hidden md:block">
                Safest <br>Car Ever
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PerformanceSpecs"
    }
</script>

<style scoped>

</style>